module.exports = __webpack_public_path__ + "static/media/tacktalk-details.556e042f.jpg";